<template>
	<modal
		:modal-id="modalId"
		:title="modalTitle"
		@submit="submit"
		@close-modal="closeModal"
	>
		<template slot="body">
			<class-table-form-without-modal
				ref="classTableForm"
				:table-id="tableId"
				:form-id="formId"
				:row-data="rowData"
				:selected-url="selectedUrl"
				:on-after-submit="closeModal"
			/>
		</template>
	</modal>
</template>

<script>
import ClassTableFormWithoutModal from "./ClassTableFormWithoutModal.vue";
import { ModalMixin } from "../../../../../../../Mixins/ModalMixin";

export default {
	name: "ClassTableForm",
	components: { ClassTableFormWithoutModal },
	mixins: [ModalMixin],
	props: {
		tableId: String,
		formId: String,
		value: {
			type: Object,
			default: () => {
				return {
					code: "",
					name: "",
					is_active: "",
				};
			},
		},
		rowData: {
			type: Object,
			default: () => {
				return {
					id: "",
					clc_id_number: "",
				};
			},
		},
		selectedUrl: String,
	},
	data() {
		return {
			modalId: this.formId,
			modalTitle: this.$t("add"),
		};
	},
	computed: {
		// modalValue: {
		// 	get() {
		// 		console.log(this.value);
		// 		return this.value;
		// 	},
		// 	set(newVal) {
		// 		this.$emit('input', newVal);
		// 		console.log('ClassTableForm.modalValue:', newVal);
		// 	},
		// },
	},
	methods: {
		submit() {
			this.$refs.classTableForm.submit();
		},
	},
};
</script>
